import React, { useCallback, useMemo, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import {
  DataTable,
  DisplayOrder,
  SubHeading,
  Switch,
  Tooltip,
} from "../../shared/Components";
import { uiActions } from "../../store/ui/ui-slice";
import { dispatch } from "../../store";
import { getAxios, patchAxios } from "../../shared/Services/commonService";
import { API_GET_SPORT, API_UPDATE_SPORT } from "../../utils/api/ApiConstant";
import { SPORT_MODES } from "../../shared/helper/common";

const Sports = () => {
  const queryClient = useQueryClient();

  const { isLoading, data, refetch } = useQuery({
    queryKey: ["sportData"],
    queryFn: async () => await getAxios(API_GET_SPORT),
  });

  console.log("data", data);

  const handleOpenModal = useCallback(
    (modalName, modalTitle, rowData = {}) => {
      dispatch(
        uiActions.openModal({
          name: modalName,
          modalTitle,
          rowData,
          size: "md",
          fetchData: refetch,
        }),
      );
    },
    [dispatch],
  );

  const handleQueryClient = useCallback(
    (rowData, key, newValue) => {
      queryClient.setQueryData(["sportData"], (oldData) => {
        return oldData.map((obj) =>
          obj.Id === rowData.Id ? { ...obj, [key]: newValue } : obj,
        );
      });
    },
    [queryClient],
  );

  const handlePatchRequest = useCallback(
    async (rowData, mode, value, key) => {
      const payload = { mode, value };
      const url = `${API_UPDATE_SPORT}/${rowData?.Id}`;
      const res = await patchAxios(url, payload);

      if (res) {
        handleQueryClient(rowData, key, value);
      }
    },
    [handleQueryClient],
  );

  const columns = useMemo(
    () => [
      {
        accessorKey: "Name",
        header: "Sports",
      },
      {
        accessorKey: "isActive",
        header: "Is Active",
        cell: ({ getValue, row }) => {
          return (
            <Switch
              getValue={getValue}
              onChange={() =>
                handlePatchRequest(
                  row.original,
                  SPORT_MODES.IS_ACTIVE,
                  Number(!getValue()),
                  "isActive",
                )
              }
            />
          );
        },
      },
      {
        accessorKey: "betLock",
        header: "Bet Lock",
        cell: ({ getValue, row }) => {
          return (
            <Switch
              getValue={getValue}
              onChange={() =>
                handlePatchRequest(
                  row.original,
                  SPORT_MODES.BET_LOCK,
                  Number(!getValue()),
                  "betLock",
                )
              }
            />
          );
        },
      },
      {
        accessorKey: "isManual",
        header: "Is Manual",
        cell: ({ getValue }) => {
          const value = getValue();
          const type = value ? "success" : "danger";
          return (
            <span className={`badge bg-${type}-subtle text-${type}`}>
              {value ? "TRUE" : "FALSE"}
            </span>
          );
        },
      },
      {
        accessorKey: "autoSettle",
        header: "Auto Settle",
        cell: ({ getValue, row }) => {
          return (
            <Switch
              getValue={getValue}
              onChange={() =>
                handlePatchRequest(
                  row.original,
                  SPORT_MODES.AUTO_SETTLE,
                  Number(!getValue()),
                  "autoSettle",
                )
              }
            />
          );
        },
      },
      {
        accessorKey: "providerMarketSetting",
        header: "Provider Market Setting",
        cell: ({ getValue, row }) => {
          return (
            <Switch
              getValue={getValue}
              onChange={() =>
                handlePatchRequest(
                  row.original,
                  SPORT_MODES.PROVIDER_MARKET_SETTING,
                  Number(!getValue()),
                  "providerMarketSetting",
                )
              }
            />
          );
        },
      },
      {
        accessorKey: "displayOrder",
        header: "Display Order",
        cell: ({ row }) => (
          <DisplayOrder
            initialValue={row.original.displayOrder}
            onConfirm={(newValue) =>
              handlePatchRequest(
                row.original,
                SPORT_MODES.DISPLAY_ORDER,
                newValue,
                "displayOrder",
              )
            }
          />
        ),
      },
    ],
    [handlePatchRequest],
  );
  return (
    <>
      <SubHeading
        subTitle="Sports"
        isAdd={true}
        handleShowHide={() => handleOpenModal("SPORTMODAL", "Add Sport")}
      />
      <div className="card-body">
        <DataTable
          columns={columns}
          data={data ?? []}
          isLoading={isLoading}
          isSearchable={false}
          isPagination={true}
          isPageSize={true}
        />
      </div>
    </>
  );
};

export default Sports;
